import ReserveImg1 from '../../images/jor-6years.jpg';
import LogoReserve1 from '../../images/logo-reserve.svg';
import Icon1_1 from '../../images/reserve-icon-1.svg';
import Icon1_2 from '../../images/reserve-icon-2.svg';
import Icon1_3 from '../../images/reserve-icon-3.svg';

import ReserveImg2 from '../../images/jor-smallbatch2.jpg';
import LogoReserveSmallBatch from '../../images/logo-reserve-small.svg';
import Icon2_1 from '../../images/jor-aged-6.svg';
import Icon2_2 from '../../images/jor-proof-103.svg';
import Icon2_3 from '../../images/jor-small-batches.svg';

export default [
  {
    id: 1,
    leftImage: ReserveImg1,
    logoImage: LogoReserve1,
    note: 'LIMITED RELEASE | ONLY AVAILABLE IN SOME MARKETS',
    description: `
      Charcoal filtered using the Lincoln County Process and aged in
      virgin American charred oak barrels, James Ownby Reserve Tennessee
      Straight Bourbon Whiskey is a rich, warm, deep caramel, easy-sipping
      spirit with a distinctly southern soul.
      94 Proof 47% ALC/ VOL
    `,
    icons: [
      { src: Icon1_1, title: 'CHARCOAL FILTERED' },
      { src: Icon1_2, title: 'OAK BARREL AGED' },
      { src: Icon1_3, title: 'EASY-SIPPING' },
    ],
    findNearbyLink: '#locator',
    buyOnlineLink:
      'https://olesmoky.com/collections/james-ownby-reserve/products/james-ownby',
    backgroundColor: '#eae1d0',
    focusId:"reserve_note"
  },
  {
    id: 1,
    leftImage: ReserveImg2,
    logoImage: LogoReserveSmallBatch,
    note: 'LIMITED RELEASE | DISTILLERY EXCLUSIVE',
    description: 'Every barrel tells a story, every taste an epic tale. In the adventurous spirit of our revolutionary forefather, James Ownby, we proudly present this Small Batch as a salute to the exceptional — a tribute to the brave soldier, whose unconventional character, like this bourbon, was unrivaled, unwavering, and undeniably distinguished. While his legacy will echo in our ancestry for ages, this Small Batch release will only last so long. Experience it if you can. Enjoy it while it lasts.<br><br><b>Only Available at our Distilleries</b>.',
    icons: [
      { src: Icon2_1, title: 'AGED 6 YEARS' },
      { src: Icon2_2, title: '103 PROOF' },
      { src: Icon2_3, title: 'MADE IN SMALL BATCHES' },
    ],
    backgroundColor: '#E1D6C3',
  },
];
